export interface CountryCode {
    code: string;
    dialCode: string;
    //flag: string;
    regex: RegExp;
    minLength: number;
    maxLength: number;
  }
  
  export const COUNTRY_CODES: CountryCode[] = [
    // Asia
    { code: 'IN', dialCode: '+91', regex: /^[6-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'CN', dialCode: '+86', regex: /^1[3-9]\d{9}$/, minLength: 11, maxLength: 11 },
    { code: 'JP', dialCode: '+81', regex: /^[789]0\d{8}$/, minLength: 11, maxLength: 11 },
    { code: 'KR', dialCode: '+82', regex: /^1[0-9]\d{7,8}$/, minLength: 9, maxLength: 10 },
    { code: 'SG', dialCode: '+65', regex: /^[89]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'MY', dialCode: '+60', regex: /^1[0-9]\d{7,8}$/, minLength: 9, maxLength: 10 },
    { code: 'TH', dialCode: '+66', regex: /^[689]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'ID', dialCode: '+62', regex: /^8\d{9,10}$/, minLength: 10, maxLength: 11 },
    { code: 'PH', dialCode: '+63', regex: /^9\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'VN', dialCode: '+84', regex: /^[3-9]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BD', dialCode: '+880', regex: /^1[3-9]\d{8}$/, minLength: 10, maxLength: 10 },
    { code: 'PK', dialCode: '+92', regex: /^3\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'LK', dialCode: '+94', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'MM', dialCode: '+95', regex: /^9\d{8,9}$/, minLength: 9, maxLength: 10 },
    { code: 'KH', dialCode: '+855', regex: /^[1-9]\d{7,8}$/, minLength: 8, maxLength: 9 },
    { code: 'LA', dialCode: '+856', regex: /^20\d{7,8}$/, minLength: 9, maxLength: 10 },
    { code: 'BN', dialCode: '+673', regex: /^[78]\d{6}$/, minLength: 7, maxLength: 7 },
    { code: 'TW', dialCode: '+886', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'HK', dialCode: '+852', regex: /^[569]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'MO', dialCode: '+853', regex: /^6\d{7}$/, minLength: 8, maxLength: 8 },
    
    // Middle East
    { code: 'SA', dialCode: '+966', regex: /^5\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'AE', dialCode: '+971', regex: /^5\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'QA', dialCode: '+974', regex: /^[3-7]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'KW', dialCode: '+965', regex: /^[569]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'BH', dialCode: '+973', regex: /^[3-9]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'OM', dialCode: '+968', regex: /^[79]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'JO', dialCode: '+962', regex: /^7[789]\d{7}$/, minLength: 9, maxLength: 9 },
    { code: 'LB', dialCode: '+961', regex: /^[37]\d{6,7}$/, minLength: 7, maxLength: 8 },
    { code: 'IL', dialCode: '+972', regex: /^5\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'IR', dialCode: '+98', regex: /^9\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'IQ', dialCode: '+964', regex: /^7[3-9]\d{8}$/, minLength: 10, maxLength: 10 },
    
    // Europe
    { code: 'UK', dialCode: '+44', regex: /^7\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'DE', dialCode: '+49', regex: /^1[5-7]\d{8,9}$/, minLength: 10, maxLength: 11 },
    { code: 'FR', dialCode: '+33', regex: /^[67]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'IT', dialCode: '+39', regex: /^3\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'ES', dialCode: '+34', regex: /^[67]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'NL', dialCode: '+31', regex: /^6\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BE', dialCode: '+32', regex: /^4\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'CH', dialCode: '+41', regex: /^7[5-9]\d{7}$/, minLength: 9, maxLength: 9 },
    { code: 'AT', dialCode: '+43', regex: /^6\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'SE', dialCode: '+46', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'NO', dialCode: '+47', regex: /^[49]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'DK', dialCode: '+45', regex: /^[2-9]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'FI', dialCode: '+358', regex: /^[45]\d{7,8}$/, minLength: 8, maxLength: 9 },
    { code: 'PL', dialCode: '+48', regex: /^[5-9]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'CZ', dialCode: '+420', regex: /^[6-9]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'HU', dialCode: '+36', regex: /^[237]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'RO', dialCode: '+40', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BG', dialCode: '+359', regex: /^[789]\d{7,8}$/, minLength: 8, maxLength: 9 },
    { code: 'GR', dialCode: '+30', regex: /^6\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'PT', dialCode: '+351', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'IE', dialCode: '+353', regex: /^8[5-9]\d{7}$/, minLength: 9, maxLength: 9 },
    { code: 'IS', dialCode: '+354', regex: /^[6-9]\d{6}$/, minLength: 7, maxLength: 7 },
    { code: 'LU', dialCode: '+352', regex: /^6\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'MT', dialCode: '+356', regex: /^[79]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'CY', dialCode: '+357', regex: /^9\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'EE', dialCode: '+372', regex: /^[5-9]\d{6,7}$/, minLength: 7, maxLength: 8 },
    { code: 'LV', dialCode: '+371', regex: /^2\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'LT', dialCode: '+370', regex: /^6\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'SK', dialCode: '+421', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'SI', dialCode: '+386', regex: /^[3-5]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'HR', dialCode: '+385', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'RS', dialCode: '+381', regex: /^6\d{7,8}$/, minLength: 8, maxLength: 9 },
    { code: 'BA', dialCode: '+387', regex: /^6\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'MK', dialCode: '+389', regex: /^7\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'AL', dialCode: '+355', regex: /^6\d{7,8}$/, minLength: 8, maxLength: 9 },
    { code: 'TR', dialCode: '+90', regex: /^5\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'RU', dialCode: '+7', regex: /^9\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'UA', dialCode: '+380', regex: /^[39]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BY', dialCode: '+375', regex: /^[29]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'MD', dialCode: '+373', regex: /^[67]\d{7}$/, minLength: 8, maxLength: 8 },
    
    // Americas
    { code: 'US', dialCode: '+1', regex: /^[2-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'CA', dialCode: '+1', regex: /^[2-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'MX', dialCode: '+52', regex: /^[1-9]\d{9,10}$/, minLength: 10, maxLength: 11 },
    { code: 'BR', dialCode: '+55', regex: /^[1-9]\d{9,10}$/, minLength: 10, maxLength: 11 },
    { code: 'AR', dialCode: '+54', regex: /^9\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'CL', dialCode: '+56', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'CO', dialCode: '+57', regex: /^3\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'PE', dialCode: '+51', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'VE', dialCode: '+58', regex: /^4\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'EC', dialCode: '+593', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BO', dialCode: '+591', regex: /^[67]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'PY', dialCode: '+595', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'UY', dialCode: '+598', regex: /^9\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'CR', dialCode: '+506', regex: /^[89]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'PA', dialCode: '+507', regex: /^[6-8]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'GT', dialCode: '+502', regex: /^[5-9]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'HN', dialCode: '+504', regex: /^[389]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'SV', dialCode: '+503', regex: /^[67]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'NI', dialCode: '+505', regex: /^[578]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'DO', dialCode: '+1', regex: /^[2-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'PR', dialCode: '+1', regex: /^[2-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'JM', dialCode: '+1', regex: /^[2-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'CU', dialCode: '+53', regex: /^5\d{7}$/, minLength: 8, maxLength: 8 },
    
    // Africa
    { code: 'ZA', dialCode: '+27', regex: /^[6-8]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'NG', dialCode: '+234', regex: /^[789]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'KE', dialCode: '+254', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'EG', dialCode: '+20', regex: /^1[0-2]\d{8}$/, minLength: 10, maxLength: 10 },
    { code: 'GH', dialCode: '+233', regex: /^[235]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'TZ', dialCode: '+255', regex: /^[67]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'UG', dialCode: '+256', regex: /^[7]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'ET', dialCode: '+251', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'MA', dialCode: '+212', regex: /^[6-7]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'DZ', dialCode: '+213', regex: /^[5-7]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'TN', dialCode: '+216', regex: /^[2-9]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'LY', dialCode: '+218', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'SD', dialCode: '+249', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'SN', dialCode: '+221', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'CI', dialCode: '+225', regex: /^[0-9]\d{9}$/, minLength: 10, maxLength: 10 },
    { code: 'CM', dialCode: '+237', regex: /^[679]\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'AO', dialCode: '+244', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'MZ', dialCode: '+258', regex: /^8[2-7]\d{7}$/, minLength: 9, maxLength: 9 },
    { code: 'ZW', dialCode: '+263', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'ZM', dialCode: '+260', regex: /^9\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BW', dialCode: '+267', regex: /^7\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'NA', dialCode: '+264', regex: /^[68]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'MU', dialCode: '+230', regex: /^5\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'RW', dialCode: '+250', regex: /^7\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'BI', dialCode: '+257', regex: /^[79]\d{7}$/, minLength: 8, maxLength: 8 },
    
    // Oceania
    { code: 'AU', dialCode: '+61', regex: /^4\d{8}$/, minLength: 9, maxLength: 9 },
    { code: 'NZ', dialCode: '+64', regex: /^[2][0-9]\d{7,8}$/, minLength: 9, maxLength: 10 },
    { code: 'FJ', dialCode: '+679', regex: /^[7-9]\d{6}$/, minLength: 7, maxLength: 7 },
    { code: 'PG', dialCode: '+675', regex: /^[7]\d{7}$/, minLength: 8, maxLength: 8 },
    { code: 'NC', dialCode: '+687', regex: /^[7-9]\d{5}$/, minLength: 6, maxLength: 6 },
    { code: 'PF', dialCode: '+689', regex: /^[87]\d{7}$/, minLength: 8, maxLength: 8 },
  ];
  